import React, { useState } from "react";
import "./dashboard.css"; // reuse your dashboard styling

function ZapierIntegration() {
  const [apiKey, setApiKey] = useState("");
  const [status, setStatus] = useState("Not Connected");

  const connectZapier = () => {
    if (!apiKey) return alert("Enter your Zapier API Key");
    setStatus("Connected");
  };

  return (
    <div className="page-container">
      <h2 className="page-title">Zapier Integration</h2>

      <div className="card">
        <h3>Automation Setup</h3>
        <p className="subtext">
          Connect your dashboard to Zapier to automate tasks, send data to apps, and trigger workflows.
        </p>

        <input
          type="text"
          placeholder="Enter API Key or OAuth Token"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          className="integration-input"
        />

        <button className="primary-btn" onClick={connectZapier}>
          Connect
        </button>

        <div className="integration-status">
          <h4>Status:</h4>
          <span className={status === "Connected" ? "connected" : "disconnected"}>
            {status}
          </span>
        </div>
      </div>

      <div className="card">
        <h3>Connected Workflows</h3>
        <ul className="workflow-list">
          <li>New Wallet → Create Zap in Zapier</li>
          <li>Activity Heatmap → Sync to Google Sheets</li>
          <li>Transactions → Update Slack Channel</li>
        </ul>
      </div>
    </div>
  );
}

export default ZapierIntegration;
